// Updated MultiPoseEdit.jsx - Add timestamp to force complete re-render
import React, { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import useOrderPackage from '../../../hooks/useOrderPackage';
import MultiPose from '../../PackageBuilders/MultiPose';
import routes from '../../../routes';
import { useCustomer } from '../../../contexts/CustomerContext';
import OptionSelectionContent from '../OptionSelection/OptionSelectionContent';
import useBackgrounds from '../../../hooks/useBackgrounds';
import useQueryString from '../../../hooks/use-query-string';
import usePricelist from '../../../hooks/usePricelist';
import AddonSheetBuilder from '../../PackageBuilders/AddonSheets';
import QUERY_KEYS from '../../../utils/QueryKeys';
import useBuyAllOption from "../../../hooks/useBuyAllOption";

export default function MultiPoseEdit() {
  const { orderPackageId } = useParams();
  const { sheetId, type } = useQueryString();
  const history = useHistory();
  const queryClient = useQueryClient();

  const { customer, setCustomer } = useCustomer();
  const { data: orderPackage } = useOrderPackage(orderPackageId);
  const { data: buyAllOption, isLoading: isLoadingBuyAll } = useBuyAllOption(orderPackage?.packageId, customer.currentSchool.id);

  const { data: backgrounds } = useBackgrounds(orderPackage && orderPackage.packageId);
  usePricelist(orderPackage && orderPackage.packageId);

  const isFetching = useIsFetching();

  const onSave = () => {
    // Clear any React Query cache
    queryClient.invalidateQueries();
    
    // Set flags to trigger both cart refetch AND component re-render
    const timestamp = Date.now();
    localStorage.setItem('needsCartRefresh', 'true');
    localStorage.setItem('lastEditTimestamp', timestamp.toString());
    
    setCustomer({ ...customer, currentOrderPackage: orderPackage });

    if (orderPackage.optionId?.toString() === buyAllOption?.id?.toString()) {
      return history.push(routes.review());
    }

    // Navigate with timestamp to force fresh data
    const confirmUrl = routes.confirm(orderPackage.id);
    const separator = confirmUrl.includes('?') ? '&' : '?';
    history.push(`${confirmUrl}${separator}refresh=${timestamp}`);
  };

  useEffect(() => {
    document.querySelectorAll('.rails-nav').forEach((node) => { node.style.display = 'none'; });

    return () => document.querySelectorAll('.rails-nav').forEach((node) => { node.style.display = 'flex'; });
  }, []);

  if (isFetching) return null;
  if (isLoadingBuyAll) return null;
  if (!orderPackage) return null;
  if (orderPackage.cart.purchased) return null;
  if (backgrounds.length === 0) return null;

  if (sheetId && type === 'Addons') {
    return (
      <AddonSheetBuilder
        isElementary={!orderPackage.package.isSeniorPortraits}
        sheetId={sheetId}
        orderPackageId={orderPackage.id}
        onSave={onSave}
      />
    );
  }

  return (
    <div>
      <MultiPose
        cartId={customer.cart.id}
        packageId={orderPackage.packageId}
        schoolId={customer.currentSchool.id}
        studentId={customer.currentStudent.id}
        optionId={orderPackage.optionId}
        onSave={onSave}
        favoriteIds={orderPackage.sheets.map((sheet) => sheet.poseId.toString())}
        sheetId={sheetId}
        sheetType={type}
        orderPackage={orderPackage}
      />
    </div>
  );
}
